<template>
    <div class="highlightSection__chartBox">
        <div class="highlightChart__wrapper">
            <div
                class="flex"
                :class="{ 'flex--wrap' : isMobile() }">
                <div
                    class="panelCard highlightMapChart__container"
                    :class="{ 'opacity-0': loading }">
                    <h5 class="hl-module text-color--dark-blue-gray highlightMapChart__container--title">
                        {{ chartTitle }}
                    </h5>
                    <slot
                        class="highlightMapChart__container--map"
                        name="map"></slot>
                </div>
                <div class="mapChartCountries__wrapper">
                    <div class="mapChartCountries__wrapper--inner">
                        <h5
                            class="hl-module margin-bottom-15 text-color--dark-blue-gray"
                            :class="{ 'margin-top-15': isMobile() }">
                            {{ trans('XMO_HIGHLIGHTS_TOP_COUNTRIES') }}
                        </h5>
                        <template v-if="loading">
                            <CardPreloader
                                v-for="index in 3"
                                :key="index" />
                        </template>
                        <template v-else>
                            <div
                                v-for="(country, index) in getTopThreeCountries"
                                :key="index"
                                class="panelCard flex mapChartCountries__wrapper--cards">
                                <div class="flex padding-all-10">
                                    <div class="flex flex--center flex--spaceBetween">
                                        <div class="mapChartCountries__wrapper--imageWrapper">
                                            <img
                                                :src="getCdnLink(`icons/flag/iso/svg_flags/${ country.isoCode.toUpperCase() }.svg`)"
                                                :alt="country.name"
                                                width="30"
                                                height="30"
                                                loading="lazy">
                                        </div>
                                    </div>
                                    <div class="margin-left-5">
                                        <p class="mapChartCountries__wrapper--country">
                                            <span>{{ country.name }}</span>
                                        </p>
                                        <p class="mapChartCountries__wrapper--revenue">
                                            <span>{{ getRevenueForCountry(country.revenue) }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div
                ref="slider"
                class="highlightMapChart__container--mapSlider padding-horizontal-7 lineheight-16"></div>
        </div>
    </div>
</template>
<script>
    import noUiSlider from 'nouislider';
    import { mapState } from 'vuex';
    import { getCdnLink } from 'tools/getCdnLink';
    import Translator from 'tools/trans';
    import { isMobile } from 'tools/isMobile';

    export default {
        components: {
            CardPreloader: () => import('outlook/components/marketHighlights/cardPreloader'),
        },
        props: {
            chartTitle: { type: String, required: true },
            loading: { type: Boolean, required: true },
        },
        computed: {
            ...mapState([
                'mapChartRankings',
                'mapChartCategories',
                'mapChartSelectedCategory',
                'mapChartUnits',
                'isGermanContent',
            ]),
            getTopThreeCountries() {
                return this.mapChartRankings?.rows
                    .map(row => {
                        return { name: row[0].value, revenue: row[1].value, isoCode: row[2].value };
                    }).sort((current, next) => next.revenue - current.revenue)
                    .slice(0, 3);
            },
        },
        watch: {
            mapChartCategories() {
                this.initSlider();
            },
        },
        methods: {
            trans: Translator.trans,
            getCdnLink,
            isMobile,
            initSlider() {
                if (this.$refs.slider && !this.$refs.slider.noUiSlider) {
                    const range = Object.keys(this.mapChartCategories);

                    const rangeSteps = {};
                    range.forEach((rangeStep, index) => {
                        const divider = 100 / (range.length - 1);
                        const percentageValue = (divider * index).toFixed();
                        const title = percentageValue === '0' ? 'min' : (percentageValue === '100' ? 'max' : `${ percentageValue }%`);
                        rangeSteps[title] = parseInt(rangeStep);
                    });

                    noUiSlider.create(this.$refs.slider, {
                        behaviour: 'drag',
                        tooltips: true,
                        format: {
                            from: Number,
                            to: value => parseInt(value),
                        },
                        start: [this.mapChartSelectedCategory],
                        snap: true,
                        range: rangeSteps,
                        pips: {
                            mode: 'steps',
                        },
                        keyboardSupport: true,
                        keyboardDefaultStep: 1,
                    });

                    const sliderHandle = this.$refs.slider.querySelector('.noUi-handle');
                    if (sliderHandle) {
                        sliderHandle.setAttribute('aria-label', 'slider');
                    }

                    this.$refs.slider.noUiSlider.on('set', values => {
                        if (this.mapChartSelectedCategory !== values[0].toString()) {
                            this.$store.commit('SET_MAP_SELECTED_CATEGORY_STATE', values[0].toString());
                            this.$emit('set-category', values[0].toString());
                        }
                    });
                }
            },
            getRevenueForCountry(countryRevenue) {
                const { suffix, unitName } = this.mapChartUnits;
                if (this.isGermanContent) {
                    return `${ countryRevenue }${ suffix }`;
                }

                return `${ countryRevenue }${ suffix } ${ unitName }`;
            },
        },
    };
</script>
